/** @module Enums */ /** typedoc */
/**
 * State Enum for indivial Service Providers (DSP)
 * Exemple : Youtube / Amazon ...
 */
var ServiceProviderStateEnum;
(function (ServiceProviderStateEnum) {
    ServiceProviderStateEnum["PendingRelease"] = "PendingRelease";
    ServiceProviderStateEnum["Released"] = "Released";
    ServiceProviderStateEnum["Failed"] = "Failed";
    ServiceProviderStateEnum["PendingTakeDown"] = "PendingTakeDown";
    ServiceProviderStateEnum["TakenDown"] = "TakenDown";
    ServiceProviderStateEnum["Live"] = "Live";
})(ServiceProviderStateEnum || (ServiceProviderStateEnum = {}));

export { ServiceProviderStateEnum };
